// extracted by mini-css-extract-plugin
export default {"section":"section-studio_section__PErEq","section__padding":"section-studio_section__padding__WY9Qh","title":"section-studio_title__CugFJ"};